import React from 'react'
import { observer } from 'mobx-react'
import { Link } from '@tanstack/react-router'

export default observer(({ title, subTitle, link }) => {
    return (
        <div
            style={{
                textAlign: 'center',
                padding: '1em',
                borderBottom: '1px solid #ccc',
                flex: '0 0 auto',
            }}
        >
            <div
                style={{
                    fontSize: '1.2em',
                    fontWeight: 'bold',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <span className="flex-1 text-center">{title}</span>
                {link && (
                    <Link to={link} className="ml-2">
                        <i
                            className="fa fa-external-link text-gray-500"
                            style={{ cursor: 'pointer' }}
                        />
                    </Link>
                )}
            </div>
            {subTitle ? <div style={{}}>{subTitle}</div> : null}
        </div>
    )
})
